/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Lottie from 'react-lottie';

const defaultOptions = {
  loop: true,
  autoplay: true,
  rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
};

export enum ILLUSTRATIONS_NAMES {
  CART,
  DONE,
  SEARCH_NO_RESULTS,
  EVENT
}
const IllustrationMapping = {
  [ILLUSTRATIONS_NAMES.CART]: 'cart',
  [ILLUSTRATIONS_NAMES.DONE]: 'done',
  [ILLUSTRATIONS_NAMES.SEARCH_NO_RESULTS]: 'noResults',
  [ILLUSTRATIONS_NAMES.EVENT]: 'event',
};
interface IllustrationProps {
  name: ILLUSTRATIONS_NAMES;
  width?: number;
  height?: number;
  className?: string;
}

const Illustration = ({
  name,
  width,
  height,
  className,
}: IllustrationProps) => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    const loadFile = async (name) => {
      const processName = IllustrationMapping[name];
      const response = await fetch(`/lottie/${processName}.json`);
      if (response?.ok) {
        const lottieFile = await response.json();
        setAnimationData(lottieFile);
      }
    };
    loadFile(name);
  }, [name]);
  return (
    <Container className={className}>
      {animationData && (
        <Lottie
          // @ts-ignore
          options={{
            ...defaultOptions,
            animationData,
          }}
          height={height}
          width={width ?? 100}
        />
      )}
    </Container>
  );
};

export default Illustration;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
